﻿import { ensureFancybox } from "@js/core/loaders/vendors";

export async function initFancybox(selector = "[data-fancybox]") {
    const items = document.querySelectorAll(selector);
    if (!items.length) return;

    const Fancybox = await ensureFancybox();
    if (!Fancybox?.bind) return;

    Fancybox.bind(selector, {});
}